import { createContext } from "react";

let client : any;
const ApolloClientContext = createContext(client);

export default ApolloClientContext;
